// import React from 'react';
// import {Helmet} from "react-helmet";
// export default function Seo({title, description, image}) {
//   return (
//     <>
//     {/* {console.log("title",title)}
//     {console.log("title",description)}
//     {console.log("title",image)} */}
//           <Helmet>
//                 <meta charset="utf-8" />
//                 <meta name="viewport" content="width=device-width, initial-scale=1" />
//                 <link rel="icon" href="../../common/images/meta/favicon.ico" type="image/x-icon"/>
//                 <title>{title?title:"Jameel Motors"}</title>
//                 <meta name="Keywords" content="" />
//                 <meta name="Description" content={description?description:"The new mobility brand of Abdul Latif Jameel Opening new frontiers in freedom"} />
//                 <meta property="og:image" content={image?image:""} />
//                 <meta property="og:image:type" content="image/png" />
//                 <meta property="og:image:width" content="436" />
//                 <meta property="og:image:height" content="228" />
//                 <meta property="og:title" content={title?title:""} />
//                 <meta property="og:description" content={description?description:""} />
//           </Helmet>
//     </>
//   );
// }

/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { GatsbySeo } from 'gatsby-plugin-next-seo';
import { Helmet } from "react-helmet";

const SEO = ({ title, description, image}) => {
  

  

  return (
            <>
            {/* <Helmet>

                <link rel="icon" href="../../common/images/meta/favicon.ico" type="image/x-icon"/>
            </Helmet> */}
    
  
        <GatsbySeo
            title = {title?title:"Jameel Motors"}
            description = { description?description:"The new mobility brand of Abdul Latif Jameel Opening new frontiers in freedom"}
  openGraph = {{
      title:  title?title:"Jameel Motors",
        description: description?description:"The new mobility brand of Abdul Latif Jameel Opening new frontiers in freedom",
          images: [
            {
              url: image?image:"https://media.jameelmotors.com/wp-content/uploads/2023/12/metaimage.jpeg",
            }

          ],
            site_name: 'https://jameelmotors.com/',
            }
}
/>
          
</>
  )
}



export default SEO


